import App from './App';
import HomePage from './components/HomePage';
import SearchPage from './components/SearchPage';
import DetailPage from './components/DetailPage';
import OrderSuccessPage from './components/OrderSuccessPage';
import TransactionPage from './components/TransactionPage';
import AuthPage from './components/AuthPage';
import RestorePasswordPage from './components/AuthPage/RestorePasswordPage';
import CompanyPage from './components/CompanyPage';
import PartnershipWidgetPage from './components/Partnership';
import ContactsPage from './components/ContactsPage';
import StaticPage from './components/Static/StaticPage';
import StaticCityPage from './components/StaticCityPage';
import OrderConfirmPage from './components/CompanyApp/OrderConfirmPage';
import SitemapPage from './components/SitemapPage';

import profileRoutes from './profileRoutes';

function gaLog(nextState) {
  if (typeof window !== 'undefined' && !!window.gtag) {
    const newPathname = nextState.location.pathname + nextState.location.search;

    window.gtag('config', 'UA-68145379-1', { page_path: newPathname });
    window.gtag('config', 'AW-806969179', { page_path: newPathname });
    window.gtag('config', 'AW-16593378555', { page_path: newPathname });

    // window.gtag('event', 'page_view', { send_to: 'UA-68145379-1' });
  }
}

function forceTrailingSlash(nextState, replace) {
  const path = nextState.location.pathname;
  if (path.slice(-1) !== '/') {
    replace({
      ...nextState.location,
      pathname: path + '/'
    });
  }
}

function onEnter(nextState, replace) {
  forceTrailingSlash(nextState, replace);

  gaLog(nextState);
}

function onRouteChanged(prevState, nextState, replace) {
  forceTrailingSlash(nextState, replace);

  gaLog(nextState);
}

export default {
  onEnter,
  onChange: onRouteChanged,
  childRoutes: [
    {
      component: App,
      path: '/:lang/',
      indexRoute: {
        component: HomePage
      },
      childRoutes: [
        {
          component: HomePage
        },
        {
          path: 'search/',
          component: SearchPage
        },
        {
          path: 'detail/:bikeId/',
          component: DetailPage
        },
        {
          path: 'order/:orderUid/',
          component: OrderSuccessPage
        },
        {
          path: 'transaction/:transactionUid/',
          component: TransactionPage
        },
        {
          path: 'accounts/register/',
          component: AuthPage
        },
        {
          path: 'accounts/restore-password/:code/',
          component: RestorePasswordPage
        },
        {
          path: 'companies/register/',
          component: CompanyPage
        },
        {
          path: 'companies/order/:orderUid/',
          component: OrderConfirmPage
        },
        {
          path: 'partnership/widget/:code/',
          component: PartnershipWidgetPage
        },
        {
          path: 'contacts/form/',
          component: ContactsPage
        },
        {
          path: 'about_us/',
          component: StaticPage
        },
        {
          path: 'privacy_policy/',
          component: StaticPage
        },
        {
          path: 'faq/',
          component: StaticPage
        },
        {
          path: 'faq-for-companies/',
          component: StaticPage
        },
        {
          path: 'terms_and_conditions/',
          component: StaticPage
        },
        {
          path: 'general_delivery_terms/',
          component: StaticPage
        },
        {
          path: 'api-and-affiliate-partner-program/',
          component: StaticPage
        },
        {
          path: 'affiliate-partner-agreement/',
          component: StaticPage
        },
        {
          path: 'sitemap/',
          component: SitemapPage
        },
        ...profileRoutes,
        {
          path: '*',
          component: StaticCityPage
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/routes.js